module.exports = __webpack_public_path__ + "img/pergola-over-door.15b0b3c5.webp";